export default "__VITE_ASSET__CqSb5rY3__"